/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from "react";
import ReactSelect, { components } from "react-select";

export const SelectContainer = ({ children, ...props }) => (
  <components.SelectContainer
    {...props}
    className="b-toolbar__filter-container"
  >
    {children}
  </components.SelectContainer>
);

export const Option = ({ children, ...props }) => (
  <components.Option {...props} className="b-toolbar__filter-option">
    {children}
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      readOnly
      className="b-toolbar__filter-option-checkbox"
    />
  </components.Option>
);

export const MenuList = ({ children, ...props }) => (
  <components.MenuList {...props}>
    {children}
    <button
      type="button"
      className="b-toolbar__filter-clear-button"
      onClick={() => props.clearValue()}
    >
      {I18n.t("job_board_filters.generic.clear")}
    </button>
  </components.MenuList>
);

const ClearIndicator = () => null;

const selectComponents = {
  SelectContainer,
  Option,
  MenuList,
  ClearIndicator,
};

export const Select = ({
  selectedOptions,
  setSelectedOptions,
  options,
  valueFunction,
  placeholder,
}) => (
  <ReactSelect
    styles={{
      container: (baseStyles, state) => ({
        ...baseStyles,
        borderColor:
          state.isFocused || state.isHover ? "#6acbc9" : "transparent",
      }),
      control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused || state.isHover ? "#6acbc9" : "black",
        boxShadow:
          state.isFocused || state.isHover ? "0 0 0 1px #6acbc9" : "none",
        "&:hover": {
          borderColor: "#6acbc9",
        },
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        width: "200px",
      }),
      menuList: (baseStyles) => ({
        ...baseStyles,
        maxHeight: "250px",
      }),
      option: (baseStyles) => ({
        ...baseStyles,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
        color: "black",
        cursor: "pointer",
        padding: "8px",
        "&:focus": {
          backgroundColor: "white",
          color: "black",
        },
        "&:hover": {
          backgroundColor: "white",
          color: "black",
        },
      }),
    }}
    value={selectedOptions.map(valueFunction)}
    isMulti
    // Keep the filter label visible and suppress value chips. This is the
    // supported v2 escape hatch — no custom ValueContainer/MultiValue needed,
    // so the Input is never torn down on select/deselect.
    controlShouldRenderValue={false}
    hideSelectedOptions={false}
    components={selectComponents}
    closeMenuOnSelect={false}
    blurInputOnSelect={false}
    options={options}
    placeholder={placeholder}
    onChange={(newSelectedOptions) => setSelectedOptions(
      (newSelectedOptions || []).map((option) => option.value),
    )}
  />
);
